import { render, staticRenderFns } from "./rootMonitor.vue?vue&type=template&id=8b1cae32&scoped=true"
import script from "./rootMonitor.vue?vue&type=script&lang=js"
export * from "./rootMonitor.vue?vue&type=script&lang=js"
import style0 from "./rootMonitor.vue?vue&type=style&index=0&id=8b1cae32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1cae32",
  null
  
)

export default component.exports